import { render } from "./EditSubsidiary.vue?vue&type=template&id=57c2e7c4&scoped=true&ts=true"
import script from "./EditSubsidiary.vue?vue&type=script&lang=ts"
export * from "./EditSubsidiary.vue?vue&type=script&lang=ts"

import "./EditSubsidiary.vue?vue&type=style&index=0&id=57c2e7c4&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c2e7c4"]])

export default __exports__